import { EmbeddedMessage, WhatsApp } from 'constants/messageMediums';
import { Code } from 'modules/campaigns/editor/styles';
import { pluralizeWord } from 'modules/campaigns/lib/utils';
import { MessageMedium } from 'modules/domains/campaign';
import { NoOpComponent } from 'utils/reactHelpers';
import { CampaignFormField, ReadOnlyField } from '../../FormFields';

import { useCampaignContext, useTemplateContext } from '../../../context';
import {
  CommaSeparatedList,
  CommaSeparatedListItem,
  LightText,
  SectionHeader,
  SectionWrapper,
} from '../Sections.styled';
import { EmbeddedContent } from './EmbeddedContent';
import { InAppContent } from './InAppContent';
import { PushContent } from './PushContent';
import { SMSContent } from './SMSContent';
import { WebPushContent } from './WebPushContent';
import { WhatsAppContent } from './WhatsAppContent';

const getDataFeedText = (feedIds: number[]) =>
  `${feedIds.length} ${pluralizeWord('feed', feedIds.length)}`;

export const CONTENT_SECTION_TEST_ID = 'content-section';

const MEDIUMS_CONTENT_SECTION_MAPPER = {
  [MessageMedium.SMS]: <SMSContent />,
  [MessageMedium.InApp]: <InAppContent />,
  [MessageMedium.WebPush]: <WebPushContent />,
  [MessageMedium.Push]: <PushContent />,
  [MessageMedium.Email]: <NoOpComponent />,
  [EmbeddedMessage]: <EmbeddedContent />,
  [WhatsApp]: <WhatsAppContent />,
};

export const ContentSection = () => {
  const { templateAndContent, dataFeeds } = useTemplateContext();
  const { dataFeedIds } = templateAndContent;
  const { campaign } = useCampaignContext();
  const { messageMedium } = campaign;

  return (
    <SectionWrapper data-test={CONTENT_SECTION_TEST_ID}>
      <SectionHeader>Content</SectionHeader>
      {MEDIUMS_CONTENT_SECTION_MAPPER?.[messageMedium]}
      <CampaignFormField labelText="Data feeds">
        <ReadOnlyField name="dataFeeds">
          {dataFeedIds?.length ? (
            <>
              {getDataFeedText(dataFeedIds)}
              <Code>
                <CommaSeparatedList>
                  {dataFeedIds.map((id) => (
                    <CommaSeparatedListItem key={id}>
                      {dataFeeds?.[id]?.name || ''}
                    </CommaSeparatedListItem>
                  ))}
                </CommaSeparatedList>
              </Code>
            </>
          ) : (
            <LightText>Not set</LightText>
          )}
        </ReadOnlyField>
      </CampaignFormField>
    </SectionWrapper>
  );
};
